module.exports = "/assets/data/fd926e841f6a560fc9fa04b680aa33b1-FK2.data.json";